module.exports = __webpack_public_path__ + "static/media/peak.e5e4b70e.svg";